<template>
  <div class="section">
    <div class="container">
      <h1 v-show="type == 'compliance'">Report Compliance Activity</h1>
      <h1 v-show="type != 'compliance'">Comments/Inquiries</h1>
      <div class="columns">
        <div v-show="showCompliance" class="column is-half">
          <p>
            Please use the form to report CTC compliance activity, whether positive or negative, to AWG, providing as much detailed information as you can, but noting at least the following so that AWG may perform an initial assessment:
            <ol>
              <li>Relevant contracting state(s)</li>
              <li>If the activity is related to a transaction:</li>
              <ol type="a">
                <li>Make and model of the relevant aircraft objects</li>
                <li>The nature of the transaction (i.e., operating lease, financing lease, aircraft financing, etc.); and</li>
                <li>The month and year the transaction was executed</li>
              </ol>
              <li>If the activity is related to legislative/regulatory activity:</li>
              <ol type="a">
                <li>A brief summary of the related activity, including (if possible) its expected impact on CTC; and</li>
                <li>The status of such activity (i.e., proposed legislation in draft form, regulations open for public comment, legislation/regulations enacted, changes in regulatory policy, practice or interpretation, changes in judicial practice or interpretation, etc.)</li>
              </ol>
              <li>Nature of CTC compliance activity (i.e., IDERA enforcement, IDERA recordation, speedy relief pending final determination, Alternative A insolvency, etc.)</li>
              <li>Whether the CTC compliance activity is completed or ongoing</li>
            </ol>
          </p>
        </div>
        <div class="column">
          <div class="panel" style="background-color:white">
            <div class="panel-block is-block">
              <div class="breathe-sm" v-if="showCompliance">
                <b-field label="Contact Type">
                  <p>{{ category }}</p>
                </b-field>
              </div>
              <div class="breathe-sm" v-if="!showCompliance">
                <b-field label="Contact Type">
                  <b-select v-model="category" @input="goToRoute()" placeholder="Select a category" data-selected="'Regular'">
                    <option v-for="opt in categories" :value="opt" :key="opt">{{opt}}</option>
                  </b-select>
                </b-field>
              </div>
              <div class="breathe-sm">
                <b-field label="First Name">
                  <b-input v-model="contact.firstname" placeholder="First Name"></b-input>
                </b-field>
              </div>
              <div class="breathe-sm">
                <b-field label="Last Name">
                  <b-input v-model="contact.lastname" placeholder="Last Name"></b-input>
                </b-field>
              </div>
              <div class="breathe-sm">
                <b-field label="Email">
                  <b-input v-model="contact.email" placeholder="Email Address" type="email"></b-input>
                </b-field>
              </div>
              <div class="breathe-sm">
                <b-field label="Organization / Group">
                  <b-input v-model="contact.group" placeholder="Organization / Group"></b-input>
                </b-field>
              </div>
              <div class="breathe-sm">
                <b-field label="Message">
                  <b-input v-model="contact.message" type="textarea" maxlength="500"></b-input>
                </b-field>
              </div>
              <div class="breathe-sm">
                <button type="button" class="button is-primary" @click="submit" :disabled="sent" :class="{'is-loading': sending}">Submit</button>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>
<script>

  export default {
    props: {
      type: String
    },
    data: function () {
      return {
        contact: {
          category: 'General Inquiry'
        },
        categories: ["Comments", "General Inquiry", "Technical Inquiry"],
        sent: false,
        sending: false
      }
    },
    computed: {
      showCompliance() {
        return this.type == 'compliance';
      },
      category() {
        if (this.type == 'compliance') {
          return 'Compliance Issue';
        }
        else if (this.type == 'technical') {
          return 'Technical Inquiry';
        }
        else if (this.type == "general") {
          return "General Inquiry";
        }
        else if (this.type == "comments") {
          return "Comments";
        }
      },

    },
    methods: {
      //refreshCategory() {
      //  this.contact.category = this.category;
      //},
      goToRoute() {
        if (this.contact.category == 'Technical Inquiry') {
          this.$router.push("/contact/technical");
        }
        else if (this.contact.category == "General Inquiry") {
          this.$router.push("/contact/general");
        }
        else if (this.contact.category == "Comments") {
          this.$router.push("/contact/comments");
        }
        //this.refreshCategory();
      },
      submit() {
        if (this.contact.firstname && this.contact.lastname && this.contact.email && this.contact.group && this.contact.message) {
          this.contact.category = this.category;
          this.sending = true;
          this.sent = true;
          this.$http.post('api/mail/contact', this.contact).then((resp) => {
            this.sending = false;
            this.$buefy.toast.open({
              duration: 4000,
              type: 'is-success',
              message: "Thank you, We've received your message!"
            });
          }).catch(err => {
            this.sending = false;
            this.sent = false;
            this.$buefy.toast.open({
              duration: 4000,
              type: 'is-error',
              message: "An issue occurred and the message was not sent."
            });
          });
        }
        else {
          this.$buefy.toast.open({
            duration: '4000',
            type: 'is-error',
            message: "Please fill out all forms."
          });
        }
      }
    },
    mounted() {

      this.$set(this.contact, 'email', this.$store.getters.user.Email || this.$store.getters.user.Username);

      if (this.$store.getters.user && this.$store.getters.GroupNames) {
        this.contact.group = this.$store.getters.user.GroupNames.join(", ");
      }

      //this.refreshCategory();
    }
  }

</script>
